import { render, staticRenderFns } from "./consultants-tama-icon.vue?vue&type=template&id=03e49645"
import script from "./consultants-tama-icon.vue?vue&type=script&lang=js"
export * from "./consultants-tama-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports